import jstz from 'jstz';
import configuration from '../../configuration';
export var getTimezone = function (defaultTimezone) {
    if (defaultTimezone === void 0) { defaultTimezone = configuration.defaultTimezone; }
    try {
        var timezone = jstz.determine();
        return timezone.name() || defaultTimezone;
    }
    catch (_a) {
        return defaultTimezone;
    }
};
//# sourceMappingURL=index.js.map